import { useEffect } from 'react'
import useGuestLogIn from '~repositories/hooks/use-guest-login'
import Mixpanel from '~utils/mixpanel'
import useLogInStatus from './use-login-status'

let hasGuestLogin = false

/**
 * 웹 페이지 최초 접근 시 익명 로그인, Mixpanel을 initialize합니다.
 */
const useAnonymousLogin = () => {
  const isLoggedIn = useLogInStatus({ isGuest: true })
  const { mutate: guestLogin, isSuccess: isGuestLoginSuccess } = useGuestLogIn()

  useEffect(() => {
    async function init() {
      hasGuestLogin = true
      await Mixpanel.init()
      const deviceId = await Mixpanel.setDistinctId()
      guestLogin({ anonymous_code: deviceId ?? null })
    }

    if (!hasGuestLogin) {
      init()
    }
  }, [guestLogin, isLoggedIn])

  return isGuestLoginSuccess
}

export default useAnonymousLogin
